import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { userDashboardAPI } from '../../services/api';
import toast from 'react-hot-toast';
import logo from '../../assets/logo.png';
import drop from '../../assets/icons/dropdown.svg';
import '../../styles/cricket/UnifiedMatchDetails.css'; // Reuse your existing styles

import '../../styles/user/UserDashboard.css';

const UserLayout = ({ children, activeTab = 'Cricket' }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();
    const desktopDropdownRef = useRef(null);
    const mobileDropdownRef = useRef(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(false);
    const [userStats, setUserStats] = useState({ balance: 0, exposure: 0 });

    // Standard "Locked" error for non-cricket pages
    const showLocked = () => toast.error("Game Locked");

    // Format currency (reused from your previous code)
    const formatCurrency = (amount) => {
        if (!amount && amount !== 0) return '₹0';
        return `₹${amount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
    };

    // Fetch user stats once on load
    useEffect(() => {
        const fetchUserStats = async () => {
            try {
                const statsResponse = await userDashboardAPI.getDashboardStats();
                let balance = 0;
                if (statsResponse?.data?.data?.balance !== undefined) {
                    balance = parseFloat(statsResponse.data.data.balance) || 0;
                } else if (statsResponse?.data?.balance !== undefined) {
                    balance = parseFloat(statsResponse.data.balance) || 0;
                }
                setUserStats({ balance, exposure: 0 });
            } catch (error) {
                console.error('Error fetching stats:', error);
                const balance = parseFloat(user?.balance) || 0;
                setUserStats({ balance, exposure: 0 });
            }
        };
        fetchUserStats();
        
        // Close dropdown if clicking outside
       
        const handleClickOutside = (event) => {
    const insideDesktop =
        desktopDropdownRef.current?.contains(event.target);

    const insideMobile =
        mobileDropdownRef.current?.contains(event.target);

    if (!insideDesktop && !insideMobile) {
        setActiveDropdown(false);
    }
};

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [user]);

    const handleLogout = async () => {
        try {
            await userDashboardAPI.logout();
            logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
            logout();
            navigate('/login');
        }
    };

    // Determine active class for nav items
    const isActive = (path) => location.pathname === path ? 'active' : '';

    return (
        <>
            {/* HEADER */}
      <header className="ce-header">
        
        {/* MOBILE HAMBURGER (Left) - Only shows on mobile via CSS */}
        <button className="mobile-hamburger" onClick={() => {
            const toggle = document.getElementById('sidebar-toggle');
            if(toggle) toggle.checked = !toggle.checked;
        }}>
            ☰
        </button>

        {/* LOGO (Center-Left) */}
        <div className="ce-logo-wrap">
            <a href="#" onClick={(e) => { e.preventDefault(); navigate('/user/dashboard'); }}>
                <img src={logo} alt="Black247" className="ce-logo" />
            </a>
        </div>

        {/* USER DETAILS (Right) */}

        {/* =========================================================== */}
        {/* DESKTOP USER DETAILS - YOUR EXACT ORIGINAL CODE, UNTOUCHED  */}
        {/* =========================================================== */}
        <div className="ce-user-details desktop-only">
            <div className="ce-user-balance">
                <div className="ce-balance-item"><span>Balance:</span><b>{formatCurrency(userStats.balance)}</b></div>
                <div className="ce-balance-item"><span>Exp:</span><b>{formatCurrency(userStats.exposure)}</b></div>
            </div>
            <div className="ce-user" ref={desktopDropdownRef}>
                <div className="ce-user-name" onClick={() => setActiveDropdown(!activeDropdown)}>
                    <span>{user?.username}</span>
                    <img src={drop} alt="dropdown" className="ce-dropdown-icon" />
                </div>
                {activeDropdown && (
                    <div className="ce-dropdown">
                        <button onClick={() => { setActiveDropdown(false); navigate('/user/account-statement'); }}>Account History</button>
                        <button onClick={() => { setActiveDropdown(false); navigate('/user/current-bets'); }}>Current Bets</button>
                        <button onClick={() => { setActiveDropdown(false); navigate('/user/change-password'); }}>Change Password</button>
                        <button className="ce-logout" onClick={handleLogout}>Logout</button>
                    </div>
                )}
            </div>
        </div>

        {/* =========================================================== */}
        {/* MOBILE USER DETAILS - BRAND NEW STRUCTURE                  */}
        {/* =========================================================== */}
        <div className="ce-user-details mobile-only">
            {/* Row 1: Balance (Top) */}
            <div className="mobile-balance-row">
                <span>Balance:</span> <b>{formatCurrency(userStats.balance)}</b>
            </div>
            
            {/* Row 2: Exposure + Username (Side by Side exactly as you asked) */}
            <div className="mobile-exposure-user-row">
                <div className="mobile-exp-block">
                    <span>Exp:</span> <b>{formatCurrency(userStats.exposure)}</b>
                </div>
                <div className="mobile-user-block" ref={mobileDropdownRef}>
                    <div className="ce-user-name" onClick={() => setActiveDropdown(!activeDropdown)}>
                        <span>{user?.username}</span>
                        <img src={drop} alt="dropdown" className="ce-dropdown-icon" />
                    </div>
                    {activeDropdown && (
                        <div className="ce-dropdown">
                            <button onClick={() => { setActiveDropdown(false); navigate('/user/account-statement'); }}>Account History</button>
                            <button onClick={() => { setActiveDropdown(false); navigate('/user/current-bets'); }}>Current Bets</button>
                            <button onClick={() => { setActiveDropdown(false); navigate('/user/change-password'); }}>Change Password</button>
                            <button className="ce-logout" onClick={handleLogout}>Logout</button>
                        </div>
                    )}
                </div>
            </div>
        </div>

    </header>

            {/* BOTTOM NAVIGATION */}
            <div className="header-bottom">
                <nav className="navbar navbar-expand">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>Home</span>
                        </li>
                        <li className="nav-item">
                            <span className="nav-link" onClick={() => toast.error("Game Locked")}>Lottery</span>
                        </li>
                        <li className="nav-item">
                            <span className={`nav-link ${isActive('/user/dashboard')}`} onClick={() => navigate("/user/dashboard")}>
                                Cricket
                            </span>
                        </li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Tennis</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Football</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Table Tennis</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Baccarat</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>32 Cards</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Teenpatti</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Poker</span></li>
                        <li className="nav-item"><span className="nav-link" onClick={showLocked}>Lucky 7</span></li>
                        <li className="nav-item">
                            <span className="nav-link ce-crash-link" onClick={showLocked}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 457.6 277.4" className="ce-crash-icon">
                                    <g><path className="cls-1" d="M61.85,273.4c-1.8-3.5-2.3-3.9-4-3-3.2,1.7-5.5,1.1-9-2.5l-3.3-3.4,4.4-1.9c2.4-1.1,8-2.2,12.4-2.6,27.1-2.5,84.1-19.2,161-47.1,32.1-11.7,80.4-30.1,81.3-31,1.2-1.2-1-1.5-11.9-1.7-10.6-.2-11.7,0-16.5,2.4-13.1,6.8-74.6,31.2-92.8,36.7l-6.9,2.1-6.4-5-6.5-4.9-3.6,1.5c-21.3,9-88,36.4-89.2,36.6-1,.2-1.6-.6-1.8-2.3-.3-2.4.5-3,7.8-6.9,4.5-2.3,7.9-4.5,7.5-4.8-.3-.4-4.3-.9-8.9-1.3-9.7-.8-17.3-4-28.2-11.9-4.8-3.5-7.8-5-10-5-4.3,0-6.4.9-6.4,2.7,0,.8,6.8,8.7,15.1,17.6,13,13.7,14.9,16.2,13.3,16.8-3.7,1.5-4.8.8-16.3-10.3-6.4-6.2-14.6-14.2-18.3-17.7l-6.7-6.5-8.8,4.2-8.8,4.2-.3-3.4c-.2-2,.2-4.4.8-5.5s6.5-4.8,13.1-8.2c11.8-6,14.2-8,12.2-10-.7-.7-4.1.5-10.2,3.5l-9.1,4.6v-2.5c0-2,1.4-3.3,7.7-7,10.3-6,17.3-8.1,22.3-6.6,2.1.6,10.7,6.3,19.1,12.6,19,14.3,29.4,19.9,35.9,19.2,5.3-.5,34-13.7,61.9-28.5,18.3-9.7,21.6-12.1,19.5-14.2-.7-.7-7.1,1.8-21.4,8.5-14.7,7-20.5,9.3-21.1,8.4-1.2-2-.1-3.3,5.6-6.3,3-1.6,5.5-3.4,5.5-4,0-.7-1.3-2.5-2.8-4l-2.9-2.7-19.8,9.6c-10.9,5.2-20,9.3-20.2,9.1-.8-.7,2.5-12.8,3.8-14.1.8-.8,9.5-5.6,19.4-10.8,17.7-9.4,18-9.6,17.8-12.7,0-1.7-.4-3.4-.7-3.7s-3.9.9-8,2.7l-7.4,3.3-8.9-9.3c-4.8-5.1-8.9-9.6-9.1-10-.5-1.4,8.8-7.9,14.6-10.1,10.4-4,10.9-3.9,118.5,11.3,35.6,5,65.5,9.7,66.5,10.4,1.6,1.1,1.6,1.4-.1,4.8l-1.7,3.7,2.8,1c1.5.5,5.8,2.1,9.5,3.6l6.9,2.5,10.1-4.3c12.4-5.2,32.9-15.6,45.6-23.2l9.4-5.5,3.2,2.4c3.2,2.4,6.9,3.1,7.9,1.6.3-.5-2.5-6.9-6.3-14.3-3.7-7.4-8.7-18.4-11-24.4-2.4-6.1-4.8-11.6-5.4-12.4-.9-1-3.3-1.2-10.7-.8-10.8.5-18.1,2.6-42,12-15.4,6-67.7,31.5-70.6,34.4-1.3,1.4-3.4,1.4-19.2-.1-9.7-.9-18-1.6-18.4-1.6-1.4,0-.8-5.5,1.1-9.7,1.6-3.4,3.9-5.4,14-12.1,14.3-9.5,28.2-16.5,37.4-18.9l6.5-1.7,9.9,3.9c14.3,5.6,16.3,5.6,39.8-1,38.2-10.6,43.5-11.8,52.2-11.9,8-.1,8.3,0,11.6,3.3,2.6,2.5,5.7,8.3,12,23,4.7,10.8,9,21.3,9.7,23.5,1.7,5.4.8,11.9-2.4,16-6.7,8.8-38,25.2-82.1,42.8-22.8,9.1-61.8,21.9-162.5,53.3-31.1,9.7-64.7,20.3-74.6,23.6-10,3.2-18.9,5.9-19.8,5.9-.8,0-2.5-1.8-3.6-4ZM291.35,168.4c3.8-2.3,7.1-6.9,5.8-8-.6-.5-144.9-20.8-158.8-22.3-1.2-.1-2,.4-2,1.3,0,1.2,15.5,4.6,72,16.1,39.6,8.1,73.7,14.7,75.9,14.8,2.3.1,5.2-.7,7.1-1.9h0ZM247.65,122c4.2-2.3,11.2-5.8,15.4-7.7,4.3-1.9,7.8-3.7,7.8-4.1s-2.8-1.3-6.2-2c-7.7-1.7-13.7-.9-22.4,3.3-6.7,3.1-18.9,11.7-18.1,12.6.6.5,9.3,1.9,13.5,2.2,1.3,0,5.8-1.9,10-4.3h0ZM282.15,115.8c7.5-3.8,10.7-6,10.5-7.1-.4-2.1-18.3-9.2-23.4-9.3-2.2,0-4.9.6-6,1.4q-2.1,1.6,10.4,6.5c2.6,1,4.8,2.3,5,2.9s-1.9,2.2-4.7,3.6c-5.5,2.8-6.6,4-5.7,6.1.8,2.3,2.3,1.9,13.9-4.1h0Z"></path><path className="cls-1" d="M440.55,196.2c-6.8-10.1-13.5-20.3-14.9-22.8-1.5-2.5-5.5-14.1-9.1-25.7l-6.5-21.3,5.1-5c2.7-2.8,5.1-4.9,5.2-4.8.1.2,5.2,9.4,11.4,20.6,11.9,21.3,15.8,31,23.1,58,3.3,11.9,3.3,12.3,1.7,15.7-.9,1.9-2.1,3.5-2.6,3.5s-6.5-8.2-13.4-18.2h0ZM454.65,206.5c.2-1.9-.5-4.6-1.7-6.7-1.8-3.1-22-30.4-24.3-32.9-1.2-1.3-3,1.5-2.2,3.5,1.2,3.4,26,39.9,26.9,39.6.6-.1,1.1-1.7,1.3-3.5h0Z"></path><path className="cls-1" d="M295.35,148.3c-13.2-2.6-24.6-4.9-25.4-5.1-.8-.2,11.3-5.4,27-11.6l28.3-11.4,5.3,5.9c2.9,3.2,5.2,6.3,5.3,6.9,0,.6-2.3,5.5-5.1,10.8-4.8,9.1-5.2,9.6-8.2,9.5-1.8-.1-14-2.3-27.2-5h0Z"></path><path className="cls-1" d="M334.85,152.1c0-.2,1.6-3.6,3.6-7.5,1.9-4,4.1-9,4.9-11.1l1.3-3.8-5.3-6.9c-5.3-6.8-5.4-6.9-3.2-8.1,2-1.1,2.6-.8,6.2,3.2,2.2,2.5,4.3,4.5,4.6,4.5s1.7-3.9,3-8.7l2.4-8.8.3,4.9c.2,2.6-.2,8-.8,11.8l-1,7,5.1,6.4,5.1,6.4-2.7,1c-2.2.9-2.9.6-5-1.8-1.3-1.5-2.5-3-2.5-3.4-.1-2.3-1.9-.1-3.9,4.6-1.2,3-2.8,5.9-3.5,6.5-1.4,1.1-8.6,4.3-8.6,3.8h0Z"></path><path className="cls-1" d="M404.75,114.7c-7.2-16.1-7.3-16.4-5.8-17.5,1.5-1,21.2-.4,24.2.7.9.4,1.7,1.4,1.7,2.2,0,4.2-12.6,21.3-15.6,21.3-.9,0-2.8-2.9-4.5-6.7h0ZM414.15,104.7c4.8-2,8.7-4,8.7-4.4,0-1.2-4.4-1.9-13.2-1.9-8.2,0-8.8.1-8.8,2,0,2.4,2.7,8,3.8,8,.4,0,4.6-1.6,9.5-3.7Z"></path><path className="cls-1" d="M385.05,75.9c-10.7-19.1-14-27.3-20.7-51.6-4-14.3-4.3-18.7-1.6-22l1.9-2.3,14.8,22.3,14.8,22.3,7.6,24.2c4.2,13.2,7.4,24.2,7.1,24.3-.3.1-3.5.3-7.1.6l-6.5.4-10.3-18.2h0ZM391.85,46.5c0-1.5-23.2-37.5-26.1-40.6-1.3-1.3-2.9,1.2-2.9,4.7,0,2.5,8.8,15.4,22.3,32.7,4.6,6,6.7,7,6.7,3.2Z"></path></g>
                                </svg>
                                <span>Crash</span>
                            </span>
                        </li>
                    </ul>
                </nav>
            </div>

            {/* MAIN 2-COLUMN WRAPPER */}
            <div className="main-content">
                
    <input type="checkbox" id="sidebar-toggle" />

        {/* 2. Dark Overlay. Clicking it closes the menu automatically */}
        <label htmlFor="sidebar-toggle" className="sidebar-overlay"></label>
    
    <aside className="ce-sidebar">

{/* Racing Sports */}
<div className="ce-sidebar-title">
    <span>Racing Sports</span>
    <span>▲</span>
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    Horse Racing
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    Greyhound Racing
</div>


{/* Others */}
<div className="ce-sidebar-title">
    <span>Others</span>
    <span>▲</span>
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our Casino
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our VIP Casino
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our Premium Casino
</div>

<div className="ce-sidebar-item ce-blink-item" onClick={showLocked}>
    Our Virtual
</div>
<div className="ce-sidebar-item" onClick={showLocked}>Live Casino</div>
<div className="ce-sidebar-item" onClick={showLocked}>Slot Game</div>
<div className="ce-sidebar-item" onClick={showLocked}>Fantasy Game</div>


{/* All Sports */}
<div className="ce-sidebar-title">
    <span>All Sports</span>
    <span>▲</span>
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Politics
</div>

<div className="ce-sidebar-item active">
    <span className="ce-plus">⊞</span>
    Cricket
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Football
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Tennis
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Table Tennis
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Badminton
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Esoccer
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Basketball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Volleyball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Snooker
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
   Ice Hockey
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    E Games
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Futsal
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Handball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Kabaddi
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Golf
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Rugby League
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Boxing
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Beach Volleyball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Mixed Martial Arts
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    MotoGP
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Chess
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Cycling
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Motorbikes
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Athletics
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Basketball 3X3
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Sumo
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Virtual Sports
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Motor Sports
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Baseball
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Rugby Union
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Darts
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    American Football
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Soccer
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Esports
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Boat Racing
</div>

<div className="ce-sidebar-item" onClick={showLocked}>
    <span className="ce-plus">⊞</span>
    Wrestling
</div>

    </aside>

                {/* RIGHT CONTENT AREA */}
                <div className="ce-content">
                    {children}
                </div>
            </div>

              <section className="footer app-footer">
                
                {/* 1. TOP ROW: Links, Support, Social */}
                <div className="footer-top">
                    <div className="footer-links">
                        <nav className="navbar navbar-expand-sm">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a className="nav-link" href="/terms-and-conditions" target="_blank">
                                        Terms and Conditions
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/responsible-gaming" target="_blank">
                                        Responsible Gaming
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="support-detail">
                        <h2>24X7 Support</h2>
                    </div>
                    <div className="social-icons-box"></div>
                </div>

                {/* 2. MIDDLE ROW: SSL Badge + Icons */}
                <div className="footer-bottom">
                    <div className="secure-logo">
                        <div>
                            <img src="https://wver.sprintstaticdata.com/v3/static/front/img/ssl.png" alt="SSL Secure" />
                        </div>
                        <div className="ml-2">
                            <b>100% SAFE</b>
                            <div>Protected connection and encrypted data.</div>
                        </div>
                    </div>
                    <div className="d-inline-block">
                        <button className="btn p-0">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/18plus.png" alt="18+" />
                        </button>
                        <a href="https://www.gamcare.org.uk/" target="_blank">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/gamecare.png" alt="Gamecare" />
                        </a>
                        <a href="https://www.gamblingtherapy.org/" target="_blank">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/gt.png" alt="GT" />
                        </a>
                    </div>
                </div>

                {/* 3. BOTTOM ROW: Copyright Text */}
                <div className="footer-text">
                    <p className="text-centerx">
                        © Copyright {new Date().getFullYear()}. All Rights Reserved. Powered by Black247.
                    </p>
                </div>
            </section>
        </>
    );
};

export default UserLayout;